






import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class SuccessButton extends Vue {
  @Prop({ default: "" }) readonly icon!: string;
  @Prop({ default: "" }) readonly id!: string;
  @Prop() readonly text!: string;
}
